export const GET_ALL_EMPLOYEES = "GET_ALL_EMPLOYEES";
export const GET_ALL_DOCTORS = "GET_ALL_DOCTORS";
export const GET_ALL_OPERATORS = "GET_ALL_OPERATORS";
export const SET_FILTER_MODE_EMPLOYEE = "SET_FILTER_MODE_EMPLOYEE";
export const GET_DOCTORS_BY_FILTER = "GET_DOCTORS_BY_FILTER";
export const GET_DOCTOR_BY_SEARCH = "GET_DOCTOR_BY_SEARCH";
export const GET_INSURANCE_COMPANIES = "GET_INSURANCE_COMPANIES";
